import classNames from 'classnames';
import React from 'react';
import { Button } from "../../../button/Button.js";
import { Input } from "../../../input/Input.js";
import styles from "../AddLinkToolbarItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function LinkCreationForm({
  name,
  href,
  onNameChange,
  onHrefChange,
  onAdd,
  isAlreadyLink,
  onRemove,
  nameRef,
  hrefRef
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.content,
    children: [/*#__PURE__*/_jsx(Input, {
      label: "Angezeigter Text",
      className: styles.input,
      value: name,
      inputRef: ref => nameRef.current = ref,
      small: true,
      onChange: event => onNameChange(event.target.value)
    }), /*#__PURE__*/_jsx(Input, {
      label: "URL",
      className: styles.input,
      value: href,
      inputRef: ref => hrefRef.current = ref,
      small: true,
      onChange: event => onHrefChange(event.target.value)
    }), isAlreadyLink && /*#__PURE__*/_jsx(Button, {
      variant: "outlined",
      className: styles.button,
      onClick: onRemove,
      small: true,
      children: "Entfernen"
    }), /*#__PURE__*/_jsx(Button, {
      className: classNames(styles.button, {
        [styles.creating]: !isAlreadyLink
      }),
      small: true,
      onClick: onAdd,
      children: isAlreadyLink ? 'Bearbeiten' : 'Hinzufügen'
    })]
  });
}